/*
* @Author: Mark Miller
* @Date:   2018-08-29 23:18:31
* @Last Modified by:   msmiller
* @Last Modified time: 2019-12-15 14:29:23
*
* Copyright (c) 2017-2018 Sharp Stone Codewerks / Mark S. Miller
*/


import { Controller } from "stimulus"

export default class extends Controller {

    view_modal(event) {
      // console.log("-=> missives_controller#view_modal clicked");
      var missive_id = event.currentTarget.getAttribute('data-missiveid');
      // console.log("-=>   missive_id = " + missive_id);

      $('#message_body').load( "/missives/" + missive_id + "/ajax" );
      $('#convo').show();
      $('#convo_reply').show();
      $('.viewbtn').removeClass('blue');
      $('#viewbtn_' + missive_id).toggleClass('blue');
      $('#' + missive_id + '_is_read').html("<i class='circle white inverted icon'></i>");
    }

    view_mobile_modal(event) {
      // console.log("-=> missives_controller#view_mobile_modal clicked");
      var missive_id = event.currentTarget.getAttribute('data-missiveid');
      // console.log("-=>   missive_id = " + missive_id);

      $('#message_body').load( "/missives/" + missive_id + "/ajax" );
      $('#view_modal_trash_button').attr("href", "/missives/" + missive_id + "/trash")
      $('#view_modal').modal('show');
      console.log('#viewbtn_' + missive_id);
      $('#' + missive_id + '_is_read i.circle').removeClass('green').addClass('outline grey');
    }


  };

  // console.log("-=> missives_controller loaded");


